import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { SegmentHistoryApiResponse } from "../model/SegmentHistoryEntry";

/**
 * Fetches all segment history entries for export.
 * Uses a large page_size to get all records in a single request.
 */
export const ExportSegmentHistoryApiService =
  async (): Promise<SegmentHistoryApiResponse> => {
    const url = "/segments/change-log/";
    const { data } = await axios.get(url, {
      params: {
        page: 1,
        page_size: 10000,
      },
    });
    return data;
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useExportSegmentHistoryApiService = () =>
  useMutation<SegmentHistoryApiResponse, AxiosError>(
    ExportSegmentHistoryApiService,
    {
      mutationKey: ["ExportSegmentHistoryApiService"],
    }
  );

export default useExportSegmentHistoryApiService;
